import { useStorage } from '@vueuse/core';
import type { RemovableRef } from '@vueuse/core';
import axios from 'axios';

const MAX_RECENTS = 10;

type ContextType = 'group' | 'orgUnit';

export function useContextSwitch(): {
    recents: RemovableRef<string[]>;
    addToRecents: (contextId: string) => void;
    getContextId: (type: ContextType, id: string | number) => string;
    switchContext: (type: ContextType, id: string | number) => Promise<unknown>;
} {
    const teamId = Spark.state.currentTeam.id;
    const recents = useStorage<string[]>(`voxie_recent_contexts_${teamId}`, []);

    const getContextId = (type: ContextType, id: string | number): string => {
        return type === 'group' ? `group_${id}` : `org_${id}`;
    };

    const addToRecents = (contextId: string): void => {
        const filtered = recents.value.filter((storedId) => storedId !== contextId);
        recents.value = [contextId, ...filtered].slice(0, MAX_RECENTS);
    };

    const switchContext = (type: ContextType, id: string | number): Promise<unknown> => {
        const contextId = getContextId(type, id);
        addToRecents(contextId);

        const switchUrl =
            type === 'group'
                ? `/settings/teams/${teamId}/groups/${id}/switch`
                : `/settings/teams/${teamId}/org-units/${id}/switch`;

        return axios.get(switchUrl);
    };

    return { recents, addToRecents, getContextId, switchContext };
}
